import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var illustration = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:center;align-items:center;", media('>=tablet'), "{justify-content:flex-end;gap:24px;}");
export var img = /*#__PURE__*/css("object-fit:contain;width:110px;", media('>=tablet'), "{width:200px;}");